/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const QUALIFY_LOGIC_MAY = 'may';
export const QUALIFY_LOGIC_MUST = 'must';
export const QUALIFY_LOGIC_MUST_ONE_OF = 'must_one_of';
export const QUALIFY_LOGIC_REJECT = 'reject';
export const QUALIFY_LOGICS = [
  QUALIFY_LOGIC_MAY,
  QUALIFY_LOGIC_MUST,
  QUALIFY_LOGIC_MUST_ONE_OF,
  QUALIFY_LOGIC_REJECT,
];

export const QUALIFY_LOGIC_OPTIONS = [
  {
    key: 'must',
    label: 'Must Select',
    nextKey: 'reject',
    value: 'must',
  },
  {
    key: 'may',
    label: 'May Select',
    nextKey: 'must',
    value: 'may' ,
  },
  {
    key: 'reject',
    label: 'Reject',
    nextKey: 'may',
    value: 'reject',
  },
];

export const RECRUIT_API_LOGIC_OPTIONS = [
  {
    key: 'must',
    label: 'Must Select',
    nextKey: 'must_one_of',
    value: 'must',
  },
  {
    key: 'must_one_of',
    label: 'Must Select One Of',
    nextKey: 'reject',
    value: 'must_one_of',
  },
  {
    key: 'may',
    label: 'May Select',
    nextKey: 'must',
    value: 'may' ,
  },
  {
    key: 'reject',
    label: 'Reject',
    nextKey: 'may',
    value: 'reject',
  },
];

export const PICK_ONE_QUALIFY_LOGIC_OPTIONS = [
  {
    key: 'may',
    label: 'Accept',
    nextKey: 'reject',
    value: 'may',
  },
  {
    key: 'reject',
    label: 'Reject',
    nextKey: 'may',
    value: 'reject',
  },
];

export const QUESTION_PICK_ANY = 'any';
export const QUESTION_PICK_NONE = 'none';
export const QUESTION_PICK_ONE = 'one';
export const QUESTION_BOOLEAN = 'boolean';
export const QUESTION_PICKS = [
  QUESTION_PICK_NONE,
  QUESTION_PICK_ANY,
  QUESTION_PICK_ONE,
  QUESTION_BOOLEAN,
];

export const QUESTION_TYPE_BOOLEAN = 'Yes / No';
export const QUESTION_TYPE_DATE = 'Date';
export const QUESTION_TYPE_FLOAT = 'Number';
export const QUESTION_TYPE_PICK_ANY = 'Pick Any';
export const QUESTION_TYPE_PICK_ONE = 'Pick One';
export const QUESTION_TYPE_PICK_ANY_GRID = 'Pick Any - Grid';
export const QUESTION_TYPE_PICK_ONE_GRID = 'Pick One - Grid';
export const QUESTION_TYPE_STRING = 'Short Answer';
export const QUESTION_TYPE_TEXT = 'Long Answer';
export const QUESTION_TYPES = [
  QUESTION_TYPE_PICK_ANY,
  QUESTION_TYPE_PICK_ONE,
  QUESTION_TYPE_PICK_ANY_GRID,
  QUESTION_TYPE_PICK_ONE_GRID,
  QUESTION_TYPE_BOOLEAN,
  QUESTION_TYPE_STRING,
  QUESTION_TYPE_TEXT,
  QUESTION_TYPE_DATE,
  QUESTION_TYPE_FLOAT,
];

export const RESPONSE_CLASS_ANSWER = 'answer';
export const RESPONSE_CLASS_BOOLEAN = 'boolean';
export const RESPONSE_CLASS_DATE = 'date';
export const RESPONSE_CLASS_FLOAT = 'float';
export const RESPONSE_CLASS_OTHER_AND_STRING = 'other_and_string';
export const RESPONSE_CLASS_STRING = 'string';
export const RESPONSE_CLASS_TEXT = 'text';
export const RESPONSE_CLASSES = [
  RESPONSE_CLASS_STRING,
  RESPONSE_CLASS_TEXT,
  RESPONSE_CLASS_ANSWER,
  RESPONSE_CLASS_OTHER_AND_STRING,
  RESPONSE_CLASS_BOOLEAN,
  RESPONSE_CLASS_DATE,
  RESPONSE_CLASS_FLOAT,
];
